
<template>
  <nav>

    <v-app-bar text app>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" v-if="this.$route.name != 'home'"></v-app-bar-nav-icon>

      <v-toolbar-title class="text-uppercase grey--text">
        <span class="font-weight-light">Markets</span>
        <span> Dashboard</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn text color="grey" @click="userSignOut" v-if="this.$route.name != 'home'">
        <span>Sign Out</span>
        <v-icon right>mdi-exit-to-app</v-icon>
      </v-btn>
    </v-app-bar>

    <v-navigation-drawer app temporary v-model="drawer" class="primary" v-if="this.$route.name != 'home'">
       <v-list>
        <v-list-item class="white--text" v-for="link in links" :key="link.text" router :to="link.route">
          <v-list-item-action>
            <v-icon v-text="link.icon"></v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title v-text="link.text"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

  </nav>
</template>

<script>
export default {
  data() {
    return {
      drawer: false,
      links: [
        // { icon: 'mdi-view-grid', text: 'Dashboard', route: '/' },
        { icon: 'mdi-calendar-multiple', text: 'Markets', route: '/markets' },
        { icon: 'mdi-account-search', text: 'Stallholders', route: '/stallholders' },
        { icon: 'mdi-shape', text: 'Categories', route: '/categories' },
        { icon: 'mdi-cash-usd', text: 'Payments', route: '/payments' },
        { icon: 'mdi-alpha-b-circle-outline', text: 'Bookings Search', route: '/bookings' },
        { icon: 'mdi-alpha-b-circle-outline', text: 'Bulk Invite', route: '/bulk-send-booking-invites' }
      ]
    }
  },
  methods: {
    userSignOut () {
      this.$store.dispatch('userSignOut')
    } 
  }
}
</script>

<style>
</style>
